import React, { useEffect, useState } from 'react';
import { Modal, message } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import NewButton from '../components/NewButton';
import { useStoreActions, useStoreState } from '../store/hooks';
import CountryTable from '../components/CountryTable';
import { CountryDetail } from '../api/types';
import CountryForm from '../components/CountryForm';
import { Mode } from '../store/types';
import useFormRef from '../hooks/useFormRef';
import { defaultCountry } from '../store/countries';

const CountryPage: React.FC = () => {
  const [isVisible, setVisible] = useState(false);
  const [mode, setMode] = useState<Mode>(Mode.VIEW);
  const detail = useStoreState(state => state.countries.detail);
  const {
    fetchList,
    createCountry,
    updateCountry,
    fetchCountry,
    setDetail,
  } = useStoreActions(actions => actions.countries);

  const { saveFormRef, formRef } = useFormRef<CountryDetail>();

  const { formatMessage } = useIntl();

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const handleEdit = async (id: number) => {
    await fetchCountry(id);
    setMode(Mode.EDIT);
    setVisible(true);
  };

  const handleView = async (id: number) => {
    await fetchCountry(id);
    setMode(Mode.VIEW);
    setVisible(true);
  };

  const handleNew = () => {
    setDetail(defaultCountry);
    setMode(Mode.CREATE);
    setVisible(true);
  };

  const handleSave = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    formRef!.validateFields((err, values) => {
      if (!err) {
        const inValues = {
          ...values,
        };
        switch (mode) {
          case Mode.CREATE:
            createCountry(inValues).then(res => {
              if (res) {
                message.success(
                  formatMessage({ id: 'common.message.success_new' }),
                );
                setVisible(false);
              }
            });
            break;
          case Mode.EDIT:
            updateCountry(inValues).then(res => {
              if (res) {
                message.success(
                  formatMessage({ id: 'common.message.success_edit' }),
                );
                setVisible(false);
              }
            });
            break;
          default:
            break;
        }
      }
    });
  };

  return (
    <div className='countries'>
      <NewButton onClick={handleNew} />
      <CountryTable onEdit={handleEdit} onView={handleView} />
      <Modal
        title={<FormattedMessage id='countries.detail.title' />}
        visible={isVisible}
        footer={mode === Mode.VIEW ? null : undefined}
        onCancel={e => {
          e.preventDefault();
          setVisible(false);
          formRef!.resetFields();
        }}
        okText={<FormattedMessage id='common.save' />}
        onOk={handleSave}
      >
        <CountryForm ref={saveFormRef} data={detail} mode={mode} />
      </Modal>
    </div>
  );
};

export default CountryPage;
